<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header"><fa-icon [icon]="faComment"></fa-icon> {{ 'CALENDAR.REMARK' | translate }}</div>
    <div class="card-body">
      <div class="form-group mb-0">
        <textarea
          rows="3"
          class="form-control"
          id="comment"
          formControlName="comment"
                    [class.is-invalid]="
                        (form.touched || comment.touched) && comment.status === 'INVALID'
                            ? 'danger'
                            : ''
                    "
        ></textarea>

        <div class="invalid-tooltip">
          @if (
            (form.touched || comment.touched) &&
            comment.errors &&
            comment.errors['required']
            ) {
            <div
              [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
            ></div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="form.disabled"
        (click)="prev()"
        >
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        {{ 'GENERAL.PREVIOUS' | translate }}
      </button>
    </div>
    <div class="col text-end">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="form.disabled || !form.valid"
        (click)="saveAndNext()"
        [innerText]="'GENERAL.SAVE' | translate"
      ></button>
    </div>
  </div>
</form>
